module.exports = __webpack_public_path__ + "static/media/19_tn.b8605064.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/19_tn.jpg
// module id = 507
// module chunks = 0